package com.tixforgigs.common.core.extensions

fun Int.toFormattedPriceString(): String {
  val s = this.toString().padStart(3, '0')
  return s.dropLast(2) + "," + s.substring(s.length - 2)
}

fun Number?.toPairOrNull(second: Number?): Pair<Number, Number>? {
  return if (this == null || second == null) null else this to second
}

fun Pair<Number, Number>.toPairOfDoubles() = first.toDouble() to second.toDouble()
